Vue.component('onboarding-create-team', {

    props: ['use_skip','next_url'],

    data() {

        return {

            team_id: '',
            team_created: false,
            name:'',
            tripadvisorLink: '',
            form: new SparkForm({
                busy: false,
                name: '',
                number_of_rooms: '',
                tripadvisor_link: ''
            }),
        }

    },

    computed: {

        next_pg_url() {

            return this.team_id ? this.next_url.replace('{team}',this.team_id) : '';
        
        }

    },

    mounted() {

        
    },

    methods: {

        createTeam(event) {
            this.form.busy = true;

            var hotelName = this.form.name;
            var instance = this;

            var data = {
                'tripadvisor-link': this.form.tripadvisor_link,
                'num-rooms':  this.form.number_of_rooms,
                'name': this.form.name,
                'invite-email': null
            }

            axios.post('/api/settings/create_hotel', data)
            .then((response) => {
                var responseData = response.data
                if ('team_id' in responseData && responseData.team_id) {
                    //swal("Congrats!", 'Hotel Created Successfully', "success");
                    instance.team_id = responseData.team_id;
                    instance.team_created = true;
                    instance.has_ta_url = true;
                    instance.name = hotelName;

                } else {
                    instance.form.busy = false;
                    swal("Error!", 'Problem creating Hotel' + ('message' in responseData ? ': ' + responseData.message : ''), "error")
                }

            })
            .catch(error => {
                //this.errorMessage = error
                instance.form.busy = false;
                console.log('Error http');
                console.log(error)
                console.log(error.response)
                var errorMessage = ('message' in error.response.data ? ': ' + error.response.data.message : '' ) + ' Please fill-in all fields.'
                swal("Error!", 'Problem creating Hotel' + errorMessage, "error");
            })

        },

        onSelectedTripadvisorResult( selectedResult ) {
            // console.log(selectedResult)
            this.form.name = selectedResult.name
            this.form.tripadvisor_link = selectedResult.url
        }

    }


});